export const formatFilterExpression = (expression: string): string => {
  const orParts = expression.split(/\s+OR\s+/);
  return orParts
    .map((part, index) => {
      const formatted = part.replace(/\s+AND\s+/g, "\n    AND ").trim();
      return index === 0 ? formatted : `OR ${formatted}`;
    })
    .join("\n\n");
};
